import { ConcreteEncodable } from "./ConcreteEncodable";

import { NdfSourceImplEncoder } from "../../encoder/NdfSourceImplEncoder";

import * as CubiqTS from "../../index";
import { NdfSource } from "../NdfSource";

export class NdfSourceImpl extends ConcreteEncodable implements NdfSource {
  public static enType: string = "com.bcdfx.model.NdfSourceImpl";

  /*FID=1*/
  public ccyPair: string;
  /*FID=2*/
  public fixingCode: string;
  /*FID=3*/
  public id: CubiqTS.Long | null = null;
  /*FID=4*/
  public isDefault: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = NdfSourceImplEncoder.Instance;
    this.setEncodableType(NdfSourceImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "NdfSourceImpl[" +
      "ccyPair=" +
      this.ccyPair +
      "fixingCode=" +
      this.fixingCode +
      "id=" +
      this.id +
      "isDefault=" +
      this.isDefault +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
